/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@danfoss/mosaic-core/loader';
defineCustomElements();
export const DfAccordion = /*@__PURE__*/ createReactComponent('df-accordion');
export const DfAlert = /*@__PURE__*/ createReactComponent('df-alert');
export const DfAppSwitcher = /*@__PURE__*/ createReactComponent('df-app-switcher');
export const DfChipAssist = /*@__PURE__*/ createReactComponent('df-chip-assist');
export const DfChipChoice = /*@__PURE__*/ createReactComponent('df-chip-choice');
export const DfChipFilter = /*@__PURE__*/ createReactComponent('df-chip-filter');
export const DfChipSet = /*@__PURE__*/ createReactComponent('df-chip-set');
export const DfContextMenu = /*@__PURE__*/ createReactComponent('df-context-menu');
export const DfDateInput = /*@__PURE__*/ createReactComponent('df-date-input');
export const DfDatePicker = /*@__PURE__*/ createReactComponent('df-date-picker');
export const DfDateRangeInput = /*@__PURE__*/ createReactComponent('df-date-range-input');
export const DfDateRangePicker = /*@__PURE__*/ createReactComponent('df-date-range-picker');
export const DfDateTimePicker = /*@__PURE__*/ createReactComponent('df-date-time-picker');
export const DfFileInput = /*@__PURE__*/ createReactComponent('df-file-input');
export const DfFooter = /*@__PURE__*/ createReactComponent('df-footer');
export const DfHeader = /*@__PURE__*/ createReactComponent('df-header');
export const DfInlineNotification = /*@__PURE__*/ createReactComponent('df-inline-notification');
export const DfLanguagePicker = /*@__PURE__*/ createReactComponent('df-language-picker');
export const DfLoader = /*@__PURE__*/ createReactComponent('df-loader');
export const DfMegaMenu = /*@__PURE__*/ createReactComponent('df-mega-menu');
export const DfMenuItem = /*@__PURE__*/ createReactComponent('df-menu-item');
export const DfMobileMenuWithColumns = /*@__PURE__*/ createReactComponent('df-mobile-menu-with-columns');
export const DfModal = /*@__PURE__*/ createReactComponent('df-modal');
export const DfPagination = /*@__PURE__*/ createReactComponent('df-pagination');
export const DfProductStoreHeader = /*@__PURE__*/ createReactComponent('df-product-store-header');
export const DfProgressSteps = /*@__PURE__*/ createReactComponent('df-progress-steps');
export const DfRangeSlider = /*@__PURE__*/ createReactComponent('df-range-slider');
export const DfSearchInput = /*@__PURE__*/ createReactComponent('df-search-input');
export const DfSearchInputWithForm = /*@__PURE__*/ createReactComponent('df-search-input-with-form');
export const DfSelect = /*@__PURE__*/ createReactComponent('df-select');
export const DfSelectBase = /*@__PURE__*/ createReactComponent('df-select-base');
export const DfSlider = /*@__PURE__*/ createReactComponent('df-slider');
export const DfSliderPin = /*@__PURE__*/ createReactComponent('df-slider-pin');
export const DfSliderTrack = /*@__PURE__*/ createReactComponent('df-slider-track');
export const DfSystemAlert = /*@__PURE__*/ createReactComponent('df-system-alert');
export const DfTabContent = /*@__PURE__*/ createReactComponent('df-tab-content');
export const DfTabHeader = /*@__PURE__*/ createReactComponent('df-tab-header');
export const DfTable = /*@__PURE__*/ createReactComponent('df-table');
export const DfTabs = /*@__PURE__*/ createReactComponent('df-tabs');
export const DfTimeInput = /*@__PURE__*/ createReactComponent('df-time-input');
export const DfTimePicker = /*@__PURE__*/ createReactComponent('df-time-picker');
export const DfTooltip = /*@__PURE__*/ createReactComponent('df-tooltip');
export const DfTreeItem = /*@__PURE__*/ createReactComponent('df-tree-item');
export const DfTreeView = /*@__PURE__*/ createReactComponent('df-tree-view');
//# sourceMappingURL=components.js.map